/** 車載 IVI 後台門戶（與 Overseas deviceFamily 對齊） */
export const LINUX_AUTO_DEVICE_FAMILY = 'linux_auto_infotainment'

/**
 * 與 Leo 知識庫 990241–990265、POS 990285+ 錯開；原 990240–990249 與 LEO_KNOWLEDGE_MENU_IDS 衝突導致侧栏误跳。
 */
export const LINUX_AUTO_MENU_IDS = {
  group: 990300,
  equipment: 990301,
  remoteOps: 990302,
  profileConfig: 990303,
  dataBilling: 990304,
  modelRegistry: 990305,
  partnerDelivery: 990306,
  fleetMonitor: 990307,
  dbcEntitlement: 990308,
  cabinFeatures: 990309,
  canAutoMatch: 990310
}

/** integration: live | partial | planned */
export const LINUX_AUTO_PAGES = {
  equipment: { phase: 'P0', integration: 'partial', title: '車載設備' },
  remoteOps: { phase: 'P0', integration: 'partial', title: '遠程運維' },
  profileConfig: { phase: 'P0', integration: 'partial', title: 'Profile 配置' },
  dataBilling: { phase: 'P0', integration: 'live', title: 'CAN 數據帳單' },
  modelRegistry: { phase: 'P1', integration: 'planned', title: '車型與 CAN 映射' },
  partnerDelivery: { phase: 'P1', integration: 'planned', title: '合作方交付' },
  fleetMonitor: { phase: 'P2', integration: 'planned', title: '車隊監控' },
  dbcEntitlement: { phase: 'P2', integration: 'planned', title: 'DBC 通道開通' },
  cabinFeatures: { phase: 'P1', integration: 'live', title: '五大座艙能力' },
  canAutoMatch: { phase: 'P1', integration: 'live', title: 'Leo 智能 CAN 接入' }
}



// WEBPACK FOOTER //
// ./src/constants/linuxAutoPortal.js